<ng-container *ngIf="activityInstance">
	<bp-pressable-tile
		[buttonText]="ended ? '' : activityInstance.max_attendees === attendeeCount$.getValue() ? 'Activity Full' : 'Add Students'"
		(buttonClicked)="dialogService.openDialog(addStudentDialog, cdr)"
		[buttonDisabled]="activityInstance.max_attendees === attendeeCount$.getValue()">
		<div class="tw-text-base tw-font-bold tw-truncate" [ngClass]="{ 'tw-text-navy-500': !ended, 'tw-text-gray-500': ended }">
			{{ activityInstance.activity_name }}
		</div>
		<div
			class="tw-text-xs tw-font-normal tw-flex tw-items-center tw-gap-1"
			[ngClass]="{ 'tw-text-navy-500': !ended, 'tw-text-gray-500': ended }"
			*ngIf="activityInstance.activity_schedule_type === 'custom'">
			<bp-icon [icon]="'clock-01'" [size]="'16'"></bp-icon>
			{{ activityInstance.start_time | date : 'shortTime' }} - {{ activityInstance.end_time | date : 'shortTime' }}
		</div>
		<div class="tw-flex tw-text-xs tw-gap-1 tw-items-center">
			<div *ngIf="roomName && roomIcon && roomColor" class="tw-flex tw-gap-1">
				<div class="tw-rounded-full tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center" [style.background]="roomColor">
					<img class="tw-w-2.5 tw-h-2.5" [src]="roomIcon | resolveAsset" />
				</div>
				<div class="tw-truncate" style="max-width: 59px">{{ roomName }}</div>
			</div>
			<img src="../../../assets/Ellipse%20(Gray500).svg" class="tw-h-0.5 tw-mx-2" />
			<div *ngIf="activityInstance.manager" class="tw-flex tw-gap-1">
				<div class="tw-rounded-full tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center">
					<img
						[src]="
							activityInstance.manager.profile_picture ? activityInstance.manager.profile_picture : ('./assets/Avatar Default.svg' | resolveAsset)
						"
						class="tw-rounded-full tw-h-4 tw-w-4 tw-mr-1" />
				</div>
				<div class="tw-truncate" style="max-width: 59px">{{ activityInstance.manager.display_name }}</div>
			</div>
		</div>
		<!--todo reimplement this when this is an option-->
		<!--    <div *ngIf="activityInstance.activity_schedule_type === 'custom'" class="tw-flex tw-gap-1 tw-items-center tw-text-xs">&ndash;&gt;-->
		<!--			<bp-icon [icon]="'show'"></bp-icon>-->
		<!--			Show for certain students-->
		<!--		</div>-->
		<div class="tw-flex tw-gap-1 tw-items-center tw-text-xs">
			<bp-icon [icon]="'group'"></bp-icon>
			{{ attendeeCount$ | async }}/{{ activityInstance.max_attendees }} students
		</div>
	</bp-pressable-tile>

	<!-- BEGIN ADD STUDENTS MODAL -->
	<ng-template #addStudentDialog let-dismiss>
		<sp-add-activity-students-with-override
			[activityName]="activityInstance.activity_name ?? ''"
			[maxAttendees]="activityInstance.max_attendees"
			[instance]="activityInstance"
			[dismiss]="dismiss">
		</sp-add-activity-students-with-override>
	</ng-template>

	<!-- END ADD STUDENTS MODAL -->
</ng-container>
